import { OrderPaymentMethod, OrderPaymentDetails } from './order-payment-method';

export class OrderPaymentWithApplePay extends OrderPaymentMethod {
    public async generatePaymentDetails(details: OrderPaymentDetails) {
        const { paymentMethod } = details;

        if (paymentMethod?.vendorService === OLO.Enums.PAYMENT_VENDOR_SERVICE.APPLE_PAY && Boolean(paymentMethod?.applePaymentData?.PaymentData)) {
            this._extendExecutePaymentModel(details);

            this._executePaymentModel.ApplePayToken = {
                PaymentData: {
                    ...paymentMethod.applePaymentData?.PaymentData,
                },
                TransactionIdentifier: paymentMethod.applePaymentData?.PaymentData?.Header?.TransactionId,
            };

            if (this._executePaymentModel.PaymentProvider === OLO.Enums.PAYMENT_PROVIDER.STRIPE) {
                this._executePaymentModel.ApplePayToken = null;
            }

            this._executePaymentModel.PaymentAccountId = null;
            this._executePaymentModel.Token = details.paymentMethod.applePaymentData?.PaymentData?.Token;
            this._executePaymentModel.CreditCardType = OLO.Enums.CREDIT_CARD_TYPES.APPLE_PAY;

            return this._executePaymentModel;
        }

        if (this._next) {
            return this._next.generatePaymentDetails(details);
        }

        return this._executePaymentModel;
    }
}
